import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const DownloadButton = styled(Button)`
  margin-left: auto;
  pointer-events:auto;
`;

export const StyledCSVDownloader = styled.div`
 pointer-events:none;
`;
